import React from 'react';
import {When} from "react-if";
import styles from './AdStreet.module.scss';

import LocationOnRoundedIcon from '@material-ui/icons/LocationOnRounded';
import GenericDetail
  from 'gui/components/listPage/components/ad/components/genericDetail';
import {IPlaceDetails} from "data/interfaces/products";

interface IAdStreetProps {
  placeDetails: Partial<IPlaceDetails>;
  className?: string;
}

/**
 <LinkBlock
 href={`https://maps.google.com/?q=${encodeURIComponent(props.hotelDetails.hotel.formatted_address)}`}
 style={{
                  margin: 0,
                  padding: 0,
                  display: 'inline'
                }}>{props.hotelDetails.hotel.vicinity}</LinkBlock>
 */
const AdStreet = (props: IAdStreetProps) => (
  <When
    condition={!!(props.placeDetails && props.placeDetails.vicinity)}>
    {() => (
      <GenericDetail
        className={props.className}
        title="כתובת"
        icon={LocationOnRoundedIcon}
        enableReadMore={true}
      >
          <span className={styles.address}>
              {props.placeDetails.vicinity}
          </span>
      </GenericDetail>
    )}
  </When>
);

AdStreet.defaultProps = {};
export default AdStreet;
